import CollectorService from '../services/CollectorService';
import Common from './common'
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'

const state = {
    collectors: [],
    collectorsNotFound: false,
    collectorConnectionFailed: false,
    collectorsLoaded: false,
    collectorStableVersion: '',
    collectorNewVersions: [],
    collectorOldVersions: [],
    cloudDriversNotFound: false,
    cloudDriverConnectionFailed: false,
    cloudDriverExceptions: {},
    cloudDriversLoaded: false,
    cloudDrivers: [],
    driversNotFound: false,
    driverConnectionFailed: false,
    driverExceptions: {},
    driversLoaded: false,
    drivers: [],
    elkLogs: [],
    elkLogTotal: 0,
    endpointRTLogs: [],
    endpointRTLogTotal: 0,
    lastCollectorFetchTime: null,
    lastCloudDriverFetchTime: null,
    lastDriverFetchTime: null,
    lastMonitorFetchTime: null,
    loadingMetrics: false,
    loadingCollectors: false,
    loadingDrivers: false,
    loadingMonitors: false,
    logfiles: [],
    loglevels: [],
    logs: [],
    metrics: [],
    monitors: [],
    monitorsLoaded: false,
    monitorsNotFound: false,
    monitorsConnectionFailed: false,
    // sourcesInAlarm: [],
    // srcIdsInAlarm: [],
    systemRTLogs: [],
    systemRTLogTotal: 0,
    workerSessions: []
}
const getters = {
    getCollectors(state) { return state.collectors },
    getCloudDrivers(state) { return state.cloudDrivers },
    getCloudDriverExceptions(state) { return state.cloudDriverExceptions },
    getDrivers(state) { return state.drivers },
    getDriverExceptions(state) { return state.driverExceptions },
    getMonitors(state) { return state.monitors },
    getCloudDriverSystemTypes(state) { return !state.cloudDrivers ? [] : _.uniq(_.map(state.cloudDrivers, 'systemType')) },
    getDriverSystemTypes(state) { return !state.drivers ? [] : _.uniq(_.map(state.drivers, 'systemType')) },
    getLogs(state) { return state.logs },
    getLogFiles(state) { return state.logfiles },
    getLogLevels(state) { return state.loglevels },
    getMetrics(state) { return state.metrics },
    getMetricSources(state) { return !state.metrics ? [''] : _.sortBy(_.uniq(_.map(state.metrics, 'source')), (item) => item ) },
    getFilteredMetrics: (state)=>(srcIdFilter)=> { return !state.metrics ? [] : (!srcIdFilter ? state.metrics : _.filter(state.metrics, {srcId: srcIdFilter})) },
    getFilteredMetricSources: (state)=>(srcIdFilter)=> {
        return !state.metrics ? [''] :
        ( !srcIdFilter ? getters.getMetricSources(state) :
                _.sortBy(_.uniq(_.map(_.filter(state.metrics, {srcId: srcIdFilter}),'source')), (item) => item))
        },
    getWorkerSessions(state) { return state.workerSessions },
    getElkLogs(state) { return state.elkLogs },
    getElkLogTotal(state) { return state.elkLogTotal },
    getSystemRTLogs(state) { return state.systemRTLogs },
    getSystemRTLogTotal(state) { return state.systemRTLogTotal },
    getEndpointRTLogs(state) { return state.endpointRTLogs },
    getEndpointRTLogTotal(state) { return state.endpointRTLogTotal },
    loadingCloudDrivers(state) { return state.loadingDrivers },
    cloudDriversNotFound(state) { return state.driversNotFound },
    cloudDriverConnectionFailed(state) { return state.driverConnectionFailed },
    cloudDriversLoaded(state) { return state.driversLoaded },
    loadingDrivers(state) { return state.loadingDrivers },
    driversNotFound(state) { return state.driversNotFound },
    driverConnectionFailed(state) { return state.driverConnectionFailed },
    driversLoaded(state) { return state.driversLoaded },
    loadingMonitors(state) { return state.loadingMonitors },
    monitorsNotFound(state) { return state.monitorsNotFound },
    monitorConnectionFailed(state) { return state.monitorConnectionFailed },
    monitorsLoaded(state) { return state.monitorsLoaded },
    loadingMetrics(state) {return state.loadingMetrics },
    collectorStableVersion(state) { return state.collectorStableVersion },
    collectorNewVersions(state) { return state.collectorNewVersions },
    collectorOldVersions(state) { return state.collectorOldVersions },
    loadingCollectors(state) { return state.loadingCollectors },
    collectorsNotFound(state) { return state.collectorsNotFound },
    collectorConnectionFailed(state) { return state.collectorConnectionFailed },
    collectorsLoaded(state) { return state.collectorsLoaded }
}

const mutations = {
    initialize(state) {
        Vue.set(state, 'collectors', [])
        Vue.set(state, 'collectorConnectionFailed', false)
        Vue.set(state, 'collectorsLoaded', false)
        Vue.set(state, 'collectorsNotFound', false)
        Vue.set(state, 'collectorStableVersion', '')
        Vue.set(state, 'collectorNewVersions', [])
        Vue.set(state, 'collectorOldVersions', [])
        Vue.set(state, 'cloudDrivers', [])
        Vue.set(state, 'cloudDriverConnectionFailed', false)
        Vue.set(state, 'cloudDriverExceptions', {})
        Vue.set(state, 'cloudDriversLoaded', false)
        Vue.set(state, 'cloudDriversNotFound', false)
        Vue.set(state, 'drivers', [])
        Vue.set(state, 'driverConnectionFailed', false)
        Vue.set(state, 'driverExceptions', {})
        Vue.set(state, 'driversLoaded', false)
        Vue.set(state, 'driversNotFound', false)
        Vue.set(state, 'endpointRTLogs', [])
        Vue.set(state, 'endpointRTLogTotal', 0)
        Vue.set(state, 'elkLogs', [])
        Vue.set(state, 'elkLogTotal', 0)
        Vue.set(state, 'lastCloudDriverFetchTime', null)
        Vue.set(state, 'lastDriverFetchTime', null)
        Vue.set(state, 'lastMonitorFetchTime', null)
        Vue.set(state, 'lastCollectorFetchTime', null)
        Vue.set(state, 'loadingCollectors', false)
        Vue.set(state, 'loadingDrivers', false)
        Vue.set(state, 'loadingMetrics', false)
        Vue.set(state, 'loadingMonitors', false)
        Vue.set(state, 'logfiles', [])
        Vue.set(state, 'loglevels', [])
        Vue.set(state, 'logs', [])
        Vue.set(state, 'metrics', [])
        Vue.set(state, 'monitors', [])
        Vue.set(state, 'monitorConnectionFailed', false)
        Vue.set(state, 'monitorsLoaded', false)
        Vue.set(state, 'monitorsNotFound', false)
        // Vue.set(state, 'sourcesInAlarm', [])
        // Vue.set(state, 'srcIdsInAlarm', [])
        Vue.set(state, 'systemRTLogs', [])
        Vue.set(state, 'systemRTLogTotal', 0)
        Vue.set(state, 'workerSessions', [])
    },
    setCollectors(state, collectors) {
      Vue.set(state, 'collectors', collectors)
    },
    setCloudDrivers(state, drivers) {
        Vue.set(state, 'cloudDrivers', drivers)
    },
    setDrivers(state, drivers) {
        Vue.set(state, 'drivers', drivers)
    },
    setMonitors(state, monitors) {
        Vue.set(state, 'monitors', monitors)
    },
    setLogs(state, logs) {
        Vue.set(state, 'logs', logs)
    },
    setLogFiles(state, logfiles) {
        Vue.set(state, 'logfiles', logfiles)
    },
    setLogLevels(state, loglevels) {
        Vue.set(state, 'loglevels', loglevels)
    },
    setMetrics(state, metrics) {
        Vue.set(state, 'metrics', metrics)
    },
    setWorkerSessions(state, workerSessions) {
        Vue.set(state, 'workerSessions', workerSessions)
    },
    setElkLogs(state, elkLogs) {
        Vue.set(state, 'elkLogs', elkLogs)
    },
    setElkLogTotal(state, elkLogTotal) {
        Vue.set(state, 'elkLogTotal', elkLogTotal)
    },
    setSystemRTLogs(state, rtLogs) {
        Vue.set(state, 'systemRTLogs', rtLogs)
    },
    setSystemRTLogTotal(state, rtLogTotal) {
        Vue.set(state, 'systemRTLogTotal', rtLogTotal)
    },
    setEndpointRTLogs(state, rtLogs) {
        Vue.set(state, 'endpointRTLogs', rtLogs)
    },
    setEndpointRTLogTotal(state, rtLogTotal) {
        Vue.set(state, 'endpointRTLogTotal', rtLogTotal)
    },
    setCloudDriverLoadingStatus(state, {loadingDrivers, driversLoaded, driversNotFound, driverConnectionFailed}) {
        Vue.set(state, 'loadingCloudDrivers', loadingDrivers)
        Vue.set(state, 'cloudDriversLoaded', driversLoaded)
        Vue.set(state, 'cloudDriversNotFound', driversNotFound)
        Vue.set(state, 'cloudDriverConnectionFailed', driverConnectionFailed)
    },
    setCloudDriverExceptions(state, exceptions) {
        Vue.set(state, 'cloudDriverExceptions', exceptions)
    },
    setDriverLoadingStatus(state, {loadingDrivers, driversLoaded, driversNotFound, driverConnectionFailed}) {
        Vue.set(state, 'loadingDrivers', loadingDrivers)
        Vue.set(state, 'driversLoaded', driversLoaded)
        Vue.set(state, 'driversNotFound', driversNotFound)
        Vue.set(state, 'driverConnectionFailed', driverConnectionFailed)
    },
    setDriverExceptions(state, exceptions) {
        Vue.set(state, 'driverExceptions', exceptions)
    },
    setCollectorLoadingStatus(state, {loadingCollectors, collectorsLoaded, collectorsNotFound, collectorConnectionFailed}) {
        Vue.set(state, 'loadingCollectors', loadingCollectors)
        Vue.set(state, 'collectorsLoaded', collectorsLoaded)
        Vue.set(state, 'collectorsNotFound', collectorsNotFound)
        Vue.set(state, 'collectorConnectionFailed', collectorConnectionFailed)
    },
    setMonitorLoadingStatus(state, {loadingMonitors, monitorsLoaded, monitorsNotFound, monitorConnectionFailed}) {
        Vue.set(state, 'loadingMonitors', loadingMonitors)
        Vue.set(state, 'monitorsLoaded', monitorsLoaded)
        Vue.set(state, 'monitorsNotFound', monitorsNotFound)
        Vue.set(state, 'monitorConnectionFailed', monitorConnectionFailed)
    },
    setMetricsLoadingStatus(state, loadingMetrics) {
        Vue.set(state, 'loadingMetrics', loadingMetrics)
    },
    setCollectorNewVersions(state, versions) {
        Vue.set(state, 'collectorNewVersions', versions)
    },
     setCollectorOldVersions(state, versions) {
         Vue.set(state, 'collectorOldVersions', versions)
     },
     setCollectorStableVersion(state, version) {
        Vue.set(state, 'collectorStableVersion', version)
     }
  }

function buildMetrics(data) {

    let result = []

    var id = 1;
    // const alarms = []
    // const sourcesInAlarm = []
    // const srcIdsInAlarm = []
    _.forEach(_.keys(data), (collector) => {

        _.forEach(_.keys(data[collector]), (metric) => {

            if(!metric) {
                return
            }

            // if(metric.includes('.inAlarm')) {
            //     alarms.push(metric.substring(0, metric.length - ('.inAlarm'.length)))
            //     return
               // // poll.errors.current.CucmCdrLogCollector.1079.inAlarm
            // }

            let tokens = metric.split('.')

            let newObj = { key: metric, value: data[collector][metric] }

            newObj.id = id++;
            newObj.collector = collector
            newObj.category = tokens[0]
            // newObj.inAlarm = false

            if (/^\d+$/.test(tokens[tokens.length-1])) {
                newObj.srcId = +tokens[tokens.length-1]
                newObj.source = tokens[tokens.length - 2]
                newObj.metric = tokens.slice(1, tokens.length-2).join('.')
            } else if (metric.toLowerCase().endsWith('monitor')) {
                newObj.srcId = null
                newObj.source = tokens[tokens.length - 1]
                newObj.metric = tokens.slice(1, tokens.length-1).join('.')
            } else {
                newObj.srcId = ''
                newObj.source = 'System/Data'
                newObj.metric = tokens.slice(1, tokens.length).join('.')
            }

            result.push(newObj)
        })
    })

    // _.forEach(alarms, (alarm) => {
    //     const metric = _.find(result, {key: alarm})
    //     if (metric) {
    //         metric.inAlarm = true
    //         if (!sourcesInAlarm.includes(metric.source)) {
    //             sourcesInAlarm.push(metric.source)
    //         }
    //         if (!srcIdsInAlarm.includes(metric.srcId)) {
    //             srcIdsInAlarm.push(metric.srcId)
    //         }
    //     }
    // })

    // return {metrics: result, sourcesInAlarm, srcIdsInAlarm}
    return {metrics: result}
}

function buildLogs(data) {
    let result = []

    var id = 1;
    _.forEach(_.keys(data), (collector) => {

        _.forEach(data[collector], (logline) => {

            var matches = logline.match(/(\d+\/\d+\s\d+:\d+:\d+\.\d+) (\[.*\])(\[.*\])(\[.*\]) (.*) (.*) - (.*)/)

            let newObj = { id: id++, collector }

            if (matches != null) {
                if (matches[1] && moment(matches[1], 'MM/DD HH:mm:ss.SSS').isValid()) {
                    newObj.dateTime = moment(matches[1], 'MM/DD HH:mm:ss.SSS').toDate()
                } else {
                    newObj.dateTime = matches[1]
                }

                newObj.pid = matches[2]
                newObj.srcType = matches[3]
                newObj.src = matches[4]
                newObj.logType = matches[5]
                newObj.logSrc = matches[6]
                newObj.log = matches[7]
            } else {
                newObj.log = logline
            }

            result.push(newObj)
        })

    })

    return result
}

function buildLogFiles(data) {
    let result = []

    var id = 1;
    _.forEach(_.keys(data), (collector) => {

        _.forEach(data[collector], (logfile) => {

            logfile.id = id++
            logfile.collector = collector
            result.push(logfile)
        })

    })
    return result
}

function buildLogLevels(data) {
    let result = []

    var id = 1;
    _.forEach(_.keys(data), (collector) => {

        _.forEach(_.keys(data[collector]), (loglevelKey) => {

            let loglevel = { driver: loglevelKey, loglevel: data[collector][loglevelKey] }

            loglevel.id = id++
            loglevel.collector = collector
            result.push(loglevel)
        })

    })
    return result
}

function buildDrivers(data) {
    let result = []

    var id = 1;
    _.forEach(_.keys(data), (collector) => {

        _.forEach(data[collector], (driver) => {

            driver.id = id++
            driver.collector = collector

            driver.version = `${driver.version.major}.${driver.version.minor}.${driver.version.revision}.${driver.version.patch}`

            driver.buildInfo = (!driver.cache || !driver.cache['build.info']) ? {} : JSON.parse(driver.cache['build.info'])

            result.push(driver)
        })

    })
    return result
}

function buildDriverExceptions(drivers) {
    let result = {}

    _.forEach(drivers, (driver) => {

        if (!driver.polling && (driver.pollingException || driver.driverException)) {
            result[driver.systemId] = (result[driver.systemId] || '') +
                '(' + driver.documentType + ') ' + driver.pollingException + '-' + driver.driverException + ';'
        }
    })
    return result
}

function buildCollectorInfo(data) {
    let result = []

    let wds = {}
    _.forEach(_.keys(data), (collectorId) => {
        if (_.endsWith(collectorId, '-wd')) {
            const colid = collectorId.substring(0, collectorId.indexOf('-wd'))
             wds[colid] = data[collectorId].platformVersion
        } else {
            var collector = data[collectorId]
            collector.id = collectorId

            collector.userName = collector.id.split('::')[0]
            collector.hostName = collector.id.split('::')[1]

            collector.buildInfo = (!collector.cache || !collector.cache['build.info']) ? {} : JSON.parse(collector.cache['build.info'])

            result.push(collector)
        }
    })

    if (!_.isEmpty(wds) && !_.isEmpty(result)) {
        _.forEach(result, (item) => {
            item.wdversion = wds[item.id]
        })
    }

    return result
}

function buildSessionInfo(data) {

    let result = []

    _.forEach(data, (session) => {

        if (!session || !session.appType || session.appType.toLowerCase().includes("config")) {
            return
        }

       session.duration = moment.duration(moment().diff(moment(session.updatedDate)));

        session.isAlarm = session.duration.as("minutes") >= 5

        session.isStale = !session.isAlarm && (session.duration.as("minutes") >= 2)

        session.isActive = !session.isAlarm && !session.isStale

        if (_.startsWith(session.version, '4.')) {

            session.mainVersion = _.join(_.split(session.version, '.', 3), '.')
            session.minorVersion = +_.join(_.split(session.version, '.', 2), '.')

        } else {
            session.mainVersion = session.version
        }

        if (session.miscData) {

            const tokens = session.miscData.split(';')

            _.forEach(tokens, (token) => {

                const subToken = token.split('=')

                session[subToken[0]] = (subToken.length > 1) ? subToken[1] : null
            })

        }

        result.push(session)

    })

    return result

}

function getVersions(_gaVersions, _rcVersions) {

    //clean up ga and rc versions list from nulls and blanks
    const gav = _.filter(_gaVersions, x => !!x)
    const rcv = _.filter(_rcVersions, x => !!x)

    //reverse-sort the ga list to get the latest ga version
    const gavSorted = gav.map( a => a.replace(/\d+/g, n => +n+100000 ) ).sort().reverse()
    .map( a => a.replace(/\d+/g, n => +n-100000 ) );

    const gavLatest = gavSorted[0]

    //combine all versions and reverse-sort
    const allVersions = _.uniq([...gav, ...rcv])
    const allv2 = allVersions.map( a => a.replace(/\d+/g, n => +n+100000 ) ).sort().reverse()
         .map( a => a.replace(/\d+/g, n => +n-100000 ) );

    const newVersions =  []
    const oldVersions = []

    let newv = true
    for  (let i = 0; i < allv2.length; i++) {
        if (allv2[i] === gavLatest) {
            newv = false
        } else {
            if (newv) {
                newVersions.push((allv2[i]))
            } else {
                oldVersions.push((allv2[i]))
            }
        }
    }

    //stableVersion, newVersions, oldVersions
    return { stableVersion: gavLatest, newVersions, oldVersions }
}

const actions = {
    initialize({commit}) {
        commit('initialize')
    },
    async getCollectors({ state, commit, rootState, rootGetters }, forceRefresh) {

        if (!forceRefresh && !_.isEmpty(state.collectors)
        && state.lastCollectorFetchTime
        && (moment.duration(moment().diff(state.lastCollectorFetchTime)).asMinutes() < 30)) {return true}

        if (state.loadingCollectors) {
            return true
        }

        let response

        try {
            commit('setCollectorLoadingStatus',
            {loadingCollectors: true,
                collectorsLoaded: false,
                collectorsNotFound: false,
                collectorConnectionFailed: false})

            response = await CollectorService.getCollectorInfo()

            state.lastCollectorFetchTime = moment()

            commit('setCollectors', buildCollectorInfo(response.data))

            commit('setCollectorLoadingStatus',
            {loadingCollectors: false,
                collectorsLoaded: true,
                collectorsNotFound: false,
                collectorConnectionFailed: false})

            return !_.isEmpty(response.data)
        } catch (ex) {

            var statusCode = ex.response.status
            if (ex.response && ex.response.data) {
                statusCode = ex.response.data.status
              }

            commit('setCollectorLoadingStatus',
            {loadingCollectors: false,
                collectorsLoaded: false,
                collectorsNotFound: statusCode === 404,
                collectorConnectionFailed: statusCode !== 404})

            return false
        }
    },
    async getWorkerSessions({commit}) {

        let response

        try {
            response = await CollectorService.getWorkerSessions()
            commit('setWorkerSessions', buildSessionInfo(response.data))
            } catch (ex) {
                // console.error(ex)
                // Handle error
                return
            }
    },
    async getDrivers({commit, rootGetters, dispatch, state}, forceRefresh) {

        if (!forceRefresh && !_.isEmpty(state.drivers)
                && state.lastDriverFetchTime
                && (moment.duration(moment().diff(state.lastDriverFetchTime)).asMinutes() < 30)) {
                    return
        }

        if (state.loadingDrivers) {
            return true
        }

        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Fetching drivers"}, {root: true})

            commit('setDrivers', [])

            commit('setDriverLoadingStatus',
            {loadingDrivers: true,
                driversLoaded: false,
                driversNotFound: false,
                driverConnectionFailed: false})

            const drivers = []

            response = await CollectorService.getDrivers()

            state.lastDriverFetchTime = moment()

            let regularDrivers = buildDrivers(response.data)
            drivers.splice(drivers.length, 0, ...regularDrivers)

            commit('setDrivers', drivers)

            commit('setDriverExceptions', buildDriverExceptions(drivers))

            commit('setDriverLoadingStatus',
                {loadingDrivers: false,
                    driversLoaded: state.drivers.length > 0,
                    driversNotFound: state.drivers.length === 0,
                    driverConnectionFailed: false})

            dispatch('status/setStatus', {inProgress: false, operation: "Drivers refreshed", success: true, logAction: 'listing-drivers'}, {root: true})
        } catch (ex) {
             console.error(ex)
             dispatch('status/setStatus', {inProgress: false, operation: "Error fetching drivers", failure: true, message: Common.getErrorMessage(ex)}, {root: true})

            var statusCode = ex.response.status
            if (ex.response && ex.response.data) {
                statusCode = ex.response.data.status
              }

            commit('setDriverLoadingStatus',
            {loadingDrivers: false,
                driversLoaded: false,
                driversNotFound: statusCode === 404,
                driverConnectionFailed: statusCode !== 404})

            return
        }
    },
    async getCloudDrivers({commit, rootGetters, dispatch, state}, forceRefresh) {

        if (!forceRefresh && !_.isEmpty(state.cloudDrivers)
                && state.lastCloudDriverFetchTime
                && (moment.duration(moment().diff(state.lastCloudDriverFetchTime)).asMinutes() < 30)) {
                    return
        }

        if (state.loadingCloudDrivers) {
            return true
        }

        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Fetching cloud drivers"}, {root: true})

            commit('setCloudDrivers', [])

            commit('setCloudDriverLoadingStatus',
            {loadingCloudDrivers: true,
                cloudDriversLoaded: false,
                cloudDriversNotFound: false,
                cloudDriverConnectionFailed: false})

            const cloudSystemIds = rootGetters['systems/allEnabledCloudSystemIds']

            const drivers = []
            if (cloudSystemIds && cloudSystemIds.length) {
                let ccoResponse = await CollectorService.getCcoDrivers(cloudSystemIds.join())
                if (ccoResponse.data) {
                    let ccoDrivers = buildDrivers(ccoResponse.data)
                    drivers.splice(drivers.length, 0, ...ccoDrivers)

                    commit('setCloudDrivers', drivers)
                    commit('setCloudDriverExceptions', buildDriverExceptions(drivers))

                    state.lastCloudDriverFetchTime = moment()
                }
            }


            commit('setCloudDrivers', drivers)

            commit('setCloudDriverLoadingStatus',
                {loadingCloudDrivers: false,
                    cloudDriversLoaded: state.cloudDrivers.length > 0,
                    cloudDriversNotFound: state.cloudDrivers.length === 0,
                    cloudDriverConnectionFailed: false})

            dispatch('status/setStatus', {inProgress: false, operation: "Cloud drivers refreshed", success: true, logAction: 'listing-cloud-drivers'}, {root: true})
        } catch (ex) {
             console.error(ex)
             dispatch('status/setStatus', {inProgress: false, operation: "Error fetching cloud drivers", failure: true, message: Common.getErrorMessage(ex)}, {root: true})

            var statusCode = ex.response.status
            if (ex.response && ex.response.data) {
                statusCode = ex.response.data.status
              }

            commit('setCloudDriverLoadingStatus',
            {loadingCloudDrivers: false,
                cloudDriversLoaded: false,
                cloudDriversNotFound: statusCode === 404,
                cloudDriverConnectionFailed: statusCode !== 404})

            return
        }
    },
    async getMonitors({commit, rootGetters, dispatch, state}, forceRefresh) {

        if (!forceRefresh && !_.isEmpty(state.monitors)
                && state.lastMonitorFetchTime
                && (moment.duration(moment().diff(state.lastMonitorFetchTime)).asMinutes() < 30)) {
                    return
        }

        if (state.loadingMonitors) {
            return true
        }

        let response

        try {
            // dispatch('status/setStatus', {inProgress: true, operation: "Fetching drivers"}, {root: true})

            commit('setMonitors', [])

            commit('setMonitorLoadingStatus',
            {loadingMonitors: true,
                monitorsLoaded: false,
                monitorsNotFound: false,
                monitorConnectionFailed: false})

            response = await CollectorService.getMonitors()

            state.lastMonitorFetchTime = moment()

            commit('setMonitors', buildDrivers(response.data))

            commit('setMonitorLoadingStatus',
                {loadingMonitors: false,
                    monitorsLoaded: state.monitors.length > 0,
                    monitorsNotFound: state.monitors.length === 0,
                    monitorConnectionFailed: false})

            dispatch('status/setStatus', {inProgress: false, operation: "Monitors refreshed", success: true, logAction: 'listing-monitors'}, {root: true})
        } catch (ex) {
            // console.error(ex)
            // dispatch('status/setStatus', {inProgress: false, operation: "Error fetching drivers", failure: true, message: Common.getErrorMessage(ex)}, {root: true})

            var statusCode = ex.response.status
            if (ex.response && ex.response.data) {
                statusCode = ex.response.data.status
              }

            commit('setDriverLosetMonitorLoadingStatusadingStatus',
            {loadingMonitors: false,
                monitorsLoaded: false,
                monitorsNotFound: statusCode === 404,
                monitorConnectionFailed: statusCode !== 404})

            return
        }
    },
    async getLogs({commit, rootGetters, dispatch}, filter) {

        let response

        try {
            // dispatch('status/setStatus', {inProgress: true, operation: "Fetching logs"}, {root: true})

            commit('setLogs', [])

            response = await CollectorService.getLogs(filter)

            commit('setLogs', buildLogs(response.data))

            dispatch('status/setStatus', {inProgress: false, operation: "Logs refreshed", success: true, logAction: 'listing-logs'}, {root: true})
        } catch (ex) {
            // console.error(ex)
            // dispatch('status/setStatus', {inProgress: false, operation: "Error fetching logs", failure: true, message: Common.getErrorMessage(ex)}, {root: true})
            return
        }
    },
    async getElkLogs({commit}, {sourceId, pageSize, pageNumber, sortBy, sortAsc}) {
        let response = await CollectorService.getElkLogs(sourceId, pageSize, pageNumber, sortBy, sortAsc)
        commit ('setElkLogs', response.data.items)
        commit ('setElkLogTotal', response.data.totalCount)
    },
    async getSystemRTLogs({commit}, {systemId, pageSize, pageNumber}) {
        let response = await CollectorService.getRTLogs(systemId, pageSize, pageNumber)
        commit ('setSystemRTLogs', _.map(response.data.items, (item) => {
            let itemObj = item
            try {
                itemObj = JSON.parse(item)
            } catch(e) {
                itemObj = {}
            }
            return {
                receivedTime: itemObj.receivedTime , value: item
            }}))
        commit ('setSystemRTLogTotal', response.data.totalCount)
    },
    async getEndpointRTLogs({commit}, {endpointId, pageSize, pageNumber}) {
        let response = await CollectorService.getEndpointRTLogs(endpointId, pageSize, pageNumber)
        commit ('setEndpointRTLogs', _.map(response.data.items, (item) => {
            let itemObj = item
            try {
                itemObj = JSON.parse(item)
            } catch(e) {
                itemObj = {}
            }
            return {
                receivedTime: itemObj.receivedTime , value: item
            }}))
        commit ('setEndpointRTLogTotal', response.data.totalCount)
    },
    async getLogFiles({commit, rootGetters, dispatch}) {

        let response

        try {
            // dispatch('status/setStatus', {inProgress: true, operation: "Fetching log files"}, {root: true})

            commit('setLogFiles', [])

            response = await CollectorService.getLogFiles()

            commit('setLogFiles', buildLogFiles(response.data))

            dispatch('status/setStatus', {inProgress: false, operation: "Log files refreshed", success: true, logAction: 'listing-log-files'}, {root: true})
        } catch (ex) {
            // console.error(ex)
            // dispatch('status/setStatus', {inProgress: false, operation: "Error fetching log files", failure: true, message: Common.getErrorMessage(ex)}, {root: true})
            return
        }
    },
    async getLogLevels({commit, rootGetters, dispatch}) {

        let response

        try {
            // dispatch('status/setStatus', {inProgress: true, operation: "Fetching log files"}, {root: true})

            commit('setLogLevels', [])

            response = await CollectorService.getLogLevels()

            commit('setLogLevels', buildLogLevels(response.data))

            dispatch('status/setStatus', {inProgress: false, operation: "Log levels refreshed", success: true, logAction: 'listing-log-levels'}, {root: true})
        } catch (ex) {
            // console.error(ex)
            // dispatch('status/setStatus', {inProgress: false, operation: "Error fetching log files", failure: true, message: Common.getErrorMessage(ex)}, {root: true})
            return
        }
    },
    async saveLogLevels({commit, rootGetters, dispatch}, {collectorId, logLevels}) {

        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Saving log levels"}, {root: true})

            response = await CollectorService.saveLogLevels(collectorId, logLevels)

            dispatch('status/setStatus', {inProgress: false, operation: "Log levels saved", success: true, logAction: 'saving-log-levels'}, {root: true})
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving log levels", failure: true, message: Common.getErrorMessage(ex)}, {root: true})
            return
        }
    },
    async saveAutoUpgrade({commit, rootGetters, dispatch}, autoUpgrade) {

        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Saving auto upgrade preference"}, {root: true})

            response = await CollectorService.saveAutoUpgrade(autoUpgrade)

            dispatch('status/setStatus', {inProgress: false, operation: "Auto upgrade preference saved", success: true, logAction: 'saving-auto-upgrade'}, {root: true})
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving auto upgrade preference", failure: true, message: Common.getErrorMessage(ex)}, {root: true})
            return
        }
    },
    async getAutoUpgrade({commit, rootGetters, dispatch}) {

        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Getting auto upgrade preference"}, {root: true})

            response = await CollectorService.getAutoUpgrade()

            dispatch('status/setStatus', {inProgress: false, operation: "Auto upgrade preference fetched", success: true, logAction: 'saving-auto-upgrade'}, {root: true})

            return response.data
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error getting auto upgrade preference", failure: true, message: Common.getErrorMessage(ex)}, {root: true})
            return
        }
    },
    async getMetrics({state, commit, rootGetters, dispatch}, keylike) {

        let response

        if (state.loadingMetrics) {
            return true
        }

        try {
            // dispatch('status/setStatus', {inProgress: true, operation: "Fetching metrics"}, {root: true})

            commit('setMetrics', [])
            // commit('setSourcesInAlarm', [])
            // commit('setSrcIdsInAlarm', [])

            commit('setMetricsLoadingStatus', true)
            response = await CollectorService.getMetrics(keylike)

            const metricsResult = buildMetrics(response.data)
            commit('setMetrics', metricsResult.metrics)
            // commit('setSourcesInAlarm', metricsResult.sourcesInAlarm)
            // commit('setSrcIdsInAlarm', metricsResult.srcIdsInAlarm)

            commit('setMetricsLoadingStatus', false)

            dispatch('status/setStatus', {inProgress: false, operation: "Metrics refreshed", success: true, logAction: 'listing-metrics'}, {root: true})
        } catch (ex) {
            commit('setMetricsLoadingStatus', false)

            // console.error(ex)
            // dispatch('status/setStatus', {inProgress: false, operation: "Error fetching metrics", failure: true, message: Common.getErrorMessage(ex)}, {root: true})
            return
        }
    },
    async downloadLogFile({ rootGetters, dispatch }, {collectorId, filename}) {
        dispatch('status/setStatus', {inProgress: true, operation: "Downloading log file"}, {root: true})
        try {
            let response = await CollectorService.downloadLogFile(collectorId, filename)
            if (response && response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                dispatch('status/setStatus', {inProgress: false, success: true, operation: "Log file download successful", logAction: 'downloading-log-file'}, {root: true})
                return true;
            } else {
                console.dir(response)
                dispatch('status/setStatus', {inProgress: false, operation: "Error downloading log file", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-downloading-log-file'}, {root: true})
                return false
            }
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error downloading log file", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-downloading-log-file'}, {root: true})
            alert('Error downloading log file - ' + Common.getErrorMessage(ex))
            return false
        }
    },
    async downloadFileFromS3({ rootGetters, dispatch }, {filename, version}) {
        try {
            // let response = await CollectorService.downloadFileFromVapps(filename)
            let response = await CollectorService.downloadFileFromS3(filename, version)
            if (response && response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                return true;
            } else {
                console.dir(response)
                dispatch('status/setStatus', {inProgress: false, operation: "Error downloading file", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-downloading-file'}, {root: true})
                return false
            }
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error downloading file", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-downloading-file'}, {root: true})
            alert('Error config file ' + Common.getErrorMessage(ex))
            return false
        }
    },
    async getCollectorLatestVersion({commit}) {

//        var url = '/download/api/v1/collector/latest/version';
        var gaUrl = '/download/api/v1/collector/GA/latest/ga-versions';
        var rcUrl = '/download/api/v1/collector/RC/latest/rc-versions';
        // var url = Config.appsExternalURL + '/download/api/v1/collector/latest/version';

        try {

            // let stableResponse = await CollectorService.getCollectorStableVersion()

            let gaResponse = await CollectorService.getCollectorVersionFile(gaUrl)
            let rcResponse = await CollectorService.getCollectorVersionFile(rcUrl)

            const _gaVersions = !gaResponse.data ? [] : gaResponse.data.split('\n')
            const _rcVersions = !rcResponse.data ? [] : rcResponse.data.split('\n')

            const {stableVersion, newVersions, oldVersions} = getVersions(_gaVersions, _rcVersions)

            commit('setCollectorStableVersion', stableVersion)
            commit('setCollectorNewVersions', newVersions)
            commit('setCollectorOldVersions', oldVersions)
        } catch (ex) {
            console.error(ex)
        }
    },
    async getConfigFile({ state, dispatch }, data) {
        try {

            let response = await CollectorService.getConfigFile(data)
            if (response && response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'vyoptacollector.xml');
                document.body.appendChild(link);
                link.click();
                return true;
            } else {
                console.dir(response)
                dispatch('status/setStatus', {inProgress: false, operation: "Error downloading config file", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-downloading-config-file'}, {root: true})
                return false
            }
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error downloading config file", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-downloading-config-file'}, {root: true})
            alert('Error downloading config file - ' + Common.getErrorMessage(ex))
            // Handle error
            return false
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
